import { AxiosInstance } from 'axios'
import { ListOptions, PaginatedResult } from './_types'

export enum ClinicType {
  CONVENTIONAL = 'CONVENCIONAL',
  INFUSION = 'INFUSÃO',
  PARTNER = 'PARCEIRA',
}

export enum ClinicStatus {
  WAITING = 'AGUARDANDO',
  APPROVED = 'APROVADO',
  DISAPPROVED = 'REPROVADO',
}

export enum MaterialStatus {
  WAITING = 'AGUARDANDO',
  SENT = 'ENVIADO',
}

export type Clinic = {
  id: number
  uuid: string
  name: string
  cnpj: string
  phone: string | null
  whatsapp: string
  email: string
  address: string
  number: string
  complement: string | null
  district: string
  cityId: number
  attendancePrice: number | null
  zipCode: string
  userId: number | null
  clinicId: number | null
  createdUserId: number
  pharmaceuticalId: number
  focalPointName: string
  focalPointPhone: string
  focalPointEmail: string
  private: boolean
  public: boolean
  type: ClinicType
  hasConcierge: boolean
  materialStatus: MaterialStatus | null
  status: ClinicStatus | null
  createdAt: string

  // links: ClinicTaskforceLink[]
  partnerClinics: Clinic[]
  originalClinic: Clinic | null
  // clinicHealthPlans: ClinicHealthPlan[]
  // pendingClinic: PendingClinic
}

export function clinicEndpoints(apiClient: AxiosInstance) {
  return {
    async list({
      filters,
      pagination,
      relations,
      sort,
    }: ListOptions<Clinic, 'type' | 'status', 'id' | 'createdAt', 'partnerClinics' | 'originalClinic'>): Promise<
      PaginatedResult<Clinic>
    > {
      return apiClient.get('list-clinics', {
        params: {
          pagination: pagination ? JSON.stringify(pagination) : undefined,
          filters: filters ? JSON.stringify(filters) : undefined,
          relations: relations ? JSON.stringify(relations) : undefined,
          sort: sort ? JSON.stringify(sort) : undefined,
        },
      })
    },
  }
}
